var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showFitterBadge)?_c('div',{class:[
    'made-with-movement',
    {
      '--allow-fixed': _vm.allowFixed
    }
  ]},[_c('a',{staticClass:"d-flex align-items-center",attrs:{"href":_vm.url,"target":"_blank"}},[(_vm.isDarkMode)?_c('img',{attrs:{"src":require('@/assets/images/made-with-movement-white.svg'),"alt":"Made With Movement"}}):_c('img',{attrs:{"src":require('@/assets/images/made-with-movement-black.svg'),"alt":"Made With Movement"}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }